export default {"src":"/_next/static/media/holdfastbay.c413b732.svg","height":65,"width":303,"blurWidth":0,"blurHeight":0};